/* eslint-disable */
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInt: any;
  Bytes: any;
};

export type BlockChangedFilter = {
  number_gte: Scalars['Int'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']>;
  number?: InputMaybe<Scalars['Int']>;
  number_gte?: InputMaybe<Scalars['Int']>;
};

export type Dispute = {
  __typename?: 'Dispute';
  id: Scalars['ID'];
  raiseDetail: DisputeRaiseDetail;
  raiseDetailUri: Scalars['String'];
  raisedBy: User;
  resolutionDetail?: Maybe<DisputeResolutionDetail>;
  resolutionDetailUri?: Maybe<Scalars['String']>;
  resolvedBy?: Maybe<User>;
  status?: Maybe<ResolutionStatus>;
  task: Task;
};

export type DisputeRaiseDetail = {
  __typename?: 'DisputeRaiseDetail';
  comment?: Maybe<Scalars['String']>;
  dispute: Dispute;
  disputeReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  task: Task;
};

export type DisputeRaiseDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  comment?: InputMaybe<Scalars['String']>;
  comment_contains?: InputMaybe<Scalars['String']>;
  comment_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_ends_with?: InputMaybe<Scalars['String']>;
  comment_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_gt?: InputMaybe<Scalars['String']>;
  comment_gte?: InputMaybe<Scalars['String']>;
  comment_in?: InputMaybe<Array<Scalars['String']>>;
  comment_lt?: InputMaybe<Scalars['String']>;
  comment_lte?: InputMaybe<Scalars['String']>;
  comment_not?: InputMaybe<Scalars['String']>;
  comment_not_contains?: InputMaybe<Scalars['String']>;
  comment_not_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_not_ends_with?: InputMaybe<Scalars['String']>;
  comment_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_not_in?: InputMaybe<Array<Scalars['String']>>;
  comment_not_starts_with?: InputMaybe<Scalars['String']>;
  comment_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  comment_starts_with?: InputMaybe<Scalars['String']>;
  comment_starts_with_nocase?: InputMaybe<Scalars['String']>;
  dispute?: InputMaybe<Scalars['String']>;
  disputeReason?: InputMaybe<Scalars['String']>;
  disputeReason_contains?: InputMaybe<Scalars['String']>;
  disputeReason_contains_nocase?: InputMaybe<Scalars['String']>;
  disputeReason_ends_with?: InputMaybe<Scalars['String']>;
  disputeReason_ends_with_nocase?: InputMaybe<Scalars['String']>;
  disputeReason_gt?: InputMaybe<Scalars['String']>;
  disputeReason_gte?: InputMaybe<Scalars['String']>;
  disputeReason_in?: InputMaybe<Array<Scalars['String']>>;
  disputeReason_lt?: InputMaybe<Scalars['String']>;
  disputeReason_lte?: InputMaybe<Scalars['String']>;
  disputeReason_not?: InputMaybe<Scalars['String']>;
  disputeReason_not_contains?: InputMaybe<Scalars['String']>;
  disputeReason_not_contains_nocase?: InputMaybe<Scalars['String']>;
  disputeReason_not_ends_with?: InputMaybe<Scalars['String']>;
  disputeReason_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  disputeReason_not_in?: InputMaybe<Array<Scalars['String']>>;
  disputeReason_not_starts_with?: InputMaybe<Scalars['String']>;
  disputeReason_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  disputeReason_starts_with?: InputMaybe<Scalars['String']>;
  disputeReason_starts_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_?: InputMaybe<Dispute_Filter>;
  dispute_contains?: InputMaybe<Scalars['String']>;
  dispute_contains_nocase?: InputMaybe<Scalars['String']>;
  dispute_ends_with?: InputMaybe<Scalars['String']>;
  dispute_ends_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_gt?: InputMaybe<Scalars['String']>;
  dispute_gte?: InputMaybe<Scalars['String']>;
  dispute_in?: InputMaybe<Array<Scalars['String']>>;
  dispute_lt?: InputMaybe<Scalars['String']>;
  dispute_lte?: InputMaybe<Scalars['String']>;
  dispute_not?: InputMaybe<Scalars['String']>;
  dispute_not_contains?: InputMaybe<Scalars['String']>;
  dispute_not_contains_nocase?: InputMaybe<Scalars['String']>;
  dispute_not_ends_with?: InputMaybe<Scalars['String']>;
  dispute_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_not_in?: InputMaybe<Array<Scalars['String']>>;
  dispute_not_starts_with?: InputMaybe<Scalars['String']>;
  dispute_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_starts_with?: InputMaybe<Scalars['String']>;
  dispute_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum DisputeRaiseDetail_OrderBy {
  Comment = 'comment',
  Dispute = 'dispute',
  DisputeReason = 'disputeReason',
  Id = 'id',
  Task = 'task'
}

export type DisputeResolutionDetail = {
  __typename?: 'DisputeResolutionDetail';
  comment?: Maybe<Scalars['String']>;
  dispute: Dispute;
  id: Scalars['ID'];
  task: Task;
};

export type DisputeResolutionDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  comment?: InputMaybe<Scalars['String']>;
  comment_contains?: InputMaybe<Scalars['String']>;
  comment_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_ends_with?: InputMaybe<Scalars['String']>;
  comment_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_gt?: InputMaybe<Scalars['String']>;
  comment_gte?: InputMaybe<Scalars['String']>;
  comment_in?: InputMaybe<Array<Scalars['String']>>;
  comment_lt?: InputMaybe<Scalars['String']>;
  comment_lte?: InputMaybe<Scalars['String']>;
  comment_not?: InputMaybe<Scalars['String']>;
  comment_not_contains?: InputMaybe<Scalars['String']>;
  comment_not_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_not_ends_with?: InputMaybe<Scalars['String']>;
  comment_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_not_in?: InputMaybe<Array<Scalars['String']>>;
  comment_not_starts_with?: InputMaybe<Scalars['String']>;
  comment_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  comment_starts_with?: InputMaybe<Scalars['String']>;
  comment_starts_with_nocase?: InputMaybe<Scalars['String']>;
  dispute?: InputMaybe<Scalars['String']>;
  dispute_?: InputMaybe<Dispute_Filter>;
  dispute_contains?: InputMaybe<Scalars['String']>;
  dispute_contains_nocase?: InputMaybe<Scalars['String']>;
  dispute_ends_with?: InputMaybe<Scalars['String']>;
  dispute_ends_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_gt?: InputMaybe<Scalars['String']>;
  dispute_gte?: InputMaybe<Scalars['String']>;
  dispute_in?: InputMaybe<Array<Scalars['String']>>;
  dispute_lt?: InputMaybe<Scalars['String']>;
  dispute_lte?: InputMaybe<Scalars['String']>;
  dispute_not?: InputMaybe<Scalars['String']>;
  dispute_not_contains?: InputMaybe<Scalars['String']>;
  dispute_not_contains_nocase?: InputMaybe<Scalars['String']>;
  dispute_not_ends_with?: InputMaybe<Scalars['String']>;
  dispute_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_not_in?: InputMaybe<Array<Scalars['String']>>;
  dispute_not_starts_with?: InputMaybe<Scalars['String']>;
  dispute_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_starts_with?: InputMaybe<Scalars['String']>;
  dispute_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum DisputeResolutionDetail_OrderBy {
  Comment = 'comment',
  Dispute = 'dispute',
  Id = 'id',
  Task = 'task'
}

export type Dispute_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  raiseDetail?: InputMaybe<Scalars['String']>;
  raiseDetailUri?: InputMaybe<Scalars['String']>;
  raiseDetailUri_contains?: InputMaybe<Scalars['String']>;
  raiseDetailUri_contains_nocase?: InputMaybe<Scalars['String']>;
  raiseDetailUri_ends_with?: InputMaybe<Scalars['String']>;
  raiseDetailUri_ends_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetailUri_gt?: InputMaybe<Scalars['String']>;
  raiseDetailUri_gte?: InputMaybe<Scalars['String']>;
  raiseDetailUri_in?: InputMaybe<Array<Scalars['String']>>;
  raiseDetailUri_lt?: InputMaybe<Scalars['String']>;
  raiseDetailUri_lte?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not_contains?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not_contains_nocase?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not_ends_with?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not_in?: InputMaybe<Array<Scalars['String']>>;
  raiseDetailUri_not_starts_with?: InputMaybe<Scalars['String']>;
  raiseDetailUri_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetailUri_starts_with?: InputMaybe<Scalars['String']>;
  raiseDetailUri_starts_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetail_?: InputMaybe<DisputeRaiseDetail_Filter>;
  raiseDetail_contains?: InputMaybe<Scalars['String']>;
  raiseDetail_contains_nocase?: InputMaybe<Scalars['String']>;
  raiseDetail_ends_with?: InputMaybe<Scalars['String']>;
  raiseDetail_ends_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetail_gt?: InputMaybe<Scalars['String']>;
  raiseDetail_gte?: InputMaybe<Scalars['String']>;
  raiseDetail_in?: InputMaybe<Array<Scalars['String']>>;
  raiseDetail_lt?: InputMaybe<Scalars['String']>;
  raiseDetail_lte?: InputMaybe<Scalars['String']>;
  raiseDetail_not?: InputMaybe<Scalars['String']>;
  raiseDetail_not_contains?: InputMaybe<Scalars['String']>;
  raiseDetail_not_contains_nocase?: InputMaybe<Scalars['String']>;
  raiseDetail_not_ends_with?: InputMaybe<Scalars['String']>;
  raiseDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetail_not_in?: InputMaybe<Array<Scalars['String']>>;
  raiseDetail_not_starts_with?: InputMaybe<Scalars['String']>;
  raiseDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  raiseDetail_starts_with?: InputMaybe<Scalars['String']>;
  raiseDetail_starts_with_nocase?: InputMaybe<Scalars['String']>;
  raisedBy?: InputMaybe<Scalars['String']>;
  raisedBy_?: InputMaybe<User_Filter>;
  raisedBy_contains?: InputMaybe<Scalars['String']>;
  raisedBy_contains_nocase?: InputMaybe<Scalars['String']>;
  raisedBy_ends_with?: InputMaybe<Scalars['String']>;
  raisedBy_ends_with_nocase?: InputMaybe<Scalars['String']>;
  raisedBy_gt?: InputMaybe<Scalars['String']>;
  raisedBy_gte?: InputMaybe<Scalars['String']>;
  raisedBy_in?: InputMaybe<Array<Scalars['String']>>;
  raisedBy_lt?: InputMaybe<Scalars['String']>;
  raisedBy_lte?: InputMaybe<Scalars['String']>;
  raisedBy_not?: InputMaybe<Scalars['String']>;
  raisedBy_not_contains?: InputMaybe<Scalars['String']>;
  raisedBy_not_contains_nocase?: InputMaybe<Scalars['String']>;
  raisedBy_not_ends_with?: InputMaybe<Scalars['String']>;
  raisedBy_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  raisedBy_not_in?: InputMaybe<Array<Scalars['String']>>;
  raisedBy_not_starts_with?: InputMaybe<Scalars['String']>;
  raisedBy_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  raisedBy_starts_with?: InputMaybe<Scalars['String']>;
  raisedBy_starts_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail?: InputMaybe<Scalars['String']>;
  resolutionDetailUri?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_contains?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_contains_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_ends_with?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_ends_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_gt?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_gte?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_in?: InputMaybe<Array<Scalars['String']>>;
  resolutionDetailUri_lt?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_lte?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not_contains?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not_contains_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not_ends_with?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not_in?: InputMaybe<Array<Scalars['String']>>;
  resolutionDetailUri_not_starts_with?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_starts_with?: InputMaybe<Scalars['String']>;
  resolutionDetailUri_starts_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail_?: InputMaybe<DisputeResolutionDetail_Filter>;
  resolutionDetail_contains?: InputMaybe<Scalars['String']>;
  resolutionDetail_contains_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail_ends_with?: InputMaybe<Scalars['String']>;
  resolutionDetail_ends_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail_gt?: InputMaybe<Scalars['String']>;
  resolutionDetail_gte?: InputMaybe<Scalars['String']>;
  resolutionDetail_in?: InputMaybe<Array<Scalars['String']>>;
  resolutionDetail_lt?: InputMaybe<Scalars['String']>;
  resolutionDetail_lte?: InputMaybe<Scalars['String']>;
  resolutionDetail_not?: InputMaybe<Scalars['String']>;
  resolutionDetail_not_contains?: InputMaybe<Scalars['String']>;
  resolutionDetail_not_contains_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail_not_ends_with?: InputMaybe<Scalars['String']>;
  resolutionDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail_not_in?: InputMaybe<Array<Scalars['String']>>;
  resolutionDetail_not_starts_with?: InputMaybe<Scalars['String']>;
  resolutionDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  resolutionDetail_starts_with?: InputMaybe<Scalars['String']>;
  resolutionDetail_starts_with_nocase?: InputMaybe<Scalars['String']>;
  resolvedBy?: InputMaybe<Scalars['String']>;
  resolvedBy_?: InputMaybe<User_Filter>;
  resolvedBy_contains?: InputMaybe<Scalars['String']>;
  resolvedBy_contains_nocase?: InputMaybe<Scalars['String']>;
  resolvedBy_ends_with?: InputMaybe<Scalars['String']>;
  resolvedBy_ends_with_nocase?: InputMaybe<Scalars['String']>;
  resolvedBy_gt?: InputMaybe<Scalars['String']>;
  resolvedBy_gte?: InputMaybe<Scalars['String']>;
  resolvedBy_in?: InputMaybe<Array<Scalars['String']>>;
  resolvedBy_lt?: InputMaybe<Scalars['String']>;
  resolvedBy_lte?: InputMaybe<Scalars['String']>;
  resolvedBy_not?: InputMaybe<Scalars['String']>;
  resolvedBy_not_contains?: InputMaybe<Scalars['String']>;
  resolvedBy_not_contains_nocase?: InputMaybe<Scalars['String']>;
  resolvedBy_not_ends_with?: InputMaybe<Scalars['String']>;
  resolvedBy_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  resolvedBy_not_in?: InputMaybe<Array<Scalars['String']>>;
  resolvedBy_not_starts_with?: InputMaybe<Scalars['String']>;
  resolvedBy_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  resolvedBy_starts_with?: InputMaybe<Scalars['String']>;
  resolvedBy_starts_with_nocase?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResolutionStatus>;
  status_in?: InputMaybe<Array<ResolutionStatus>>;
  status_not?: InputMaybe<ResolutionStatus>;
  status_not_in?: InputMaybe<Array<ResolutionStatus>>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum Dispute_OrderBy {
  Id = 'id',
  RaiseDetail = 'raiseDetail',
  RaiseDetailUri = 'raiseDetailUri',
  RaisedBy = 'raisedBy',
  ResolutionDetail = 'resolutionDetail',
  ResolutionDetailUri = 'resolutionDetailUri',
  ResolvedBy = 'resolvedBy',
  Status = 'status',
  Task = 'task'
}

export type Global = {
  __typename?: 'Global';
  arbitratorAddress: Scalars['Bytes'];
  escrowAddress: Scalars['Bytes'];
  feePPM: Scalars['BigInt'];
  id: Scalars['ID'];
  ownerAddress: Scalars['Bytes'];
  taskCount: Scalars['BigInt'];
  treasuryAddress: Scalars['Bytes'];
};

export type Global_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  arbitratorAddress?: InputMaybe<Scalars['Bytes']>;
  arbitratorAddress_contains?: InputMaybe<Scalars['Bytes']>;
  arbitratorAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  arbitratorAddress_not?: InputMaybe<Scalars['Bytes']>;
  arbitratorAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  arbitratorAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  escrowAddress?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_contains?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  escrowAddress_not?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  feePPM?: InputMaybe<Scalars['BigInt']>;
  feePPM_gt?: InputMaybe<Scalars['BigInt']>;
  feePPM_gte?: InputMaybe<Scalars['BigInt']>;
  feePPM_in?: InputMaybe<Array<Scalars['BigInt']>>;
  feePPM_lt?: InputMaybe<Scalars['BigInt']>;
  feePPM_lte?: InputMaybe<Scalars['BigInt']>;
  feePPM_not?: InputMaybe<Scalars['BigInt']>;
  feePPM_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  ownerAddress?: InputMaybe<Scalars['Bytes']>;
  ownerAddress_contains?: InputMaybe<Scalars['Bytes']>;
  ownerAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  ownerAddress_not?: InputMaybe<Scalars['Bytes']>;
  ownerAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  ownerAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  taskCount?: InputMaybe<Scalars['BigInt']>;
  taskCount_gt?: InputMaybe<Scalars['BigInt']>;
  taskCount_gte?: InputMaybe<Scalars['BigInt']>;
  taskCount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  taskCount_lt?: InputMaybe<Scalars['BigInt']>;
  taskCount_lte?: InputMaybe<Scalars['BigInt']>;
  taskCount_not?: InputMaybe<Scalars['BigInt']>;
  taskCount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  treasuryAddress?: InputMaybe<Scalars['Bytes']>;
  treasuryAddress_contains?: InputMaybe<Scalars['Bytes']>;
  treasuryAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  treasuryAddress_not?: InputMaybe<Scalars['Bytes']>;
  treasuryAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  treasuryAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
};

export enum Global_OrderBy {
  ArbitratorAddress = 'arbitratorAddress',
  EscrowAddress = 'escrowAddress',
  FeePpm = 'feePPM',
  Id = 'id',
  OwnerAddress = 'ownerAddress',
  TaskCount = 'taskCount',
  TreasuryAddress = 'treasuryAddress'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dispute?: Maybe<Dispute>;
  disputeRaiseDetail?: Maybe<DisputeRaiseDetail>;
  disputeRaiseDetails: Array<DisputeRaiseDetail>;
  disputeResolutionDetail?: Maybe<DisputeResolutionDetail>;
  disputeResolutionDetails: Array<DisputeResolutionDetail>;
  disputes: Array<Dispute>;
  global?: Maybe<Global>;
  globals: Array<Global>;
  task?: Maybe<Task>;
  taskApplicationDetail?: Maybe<TaskApplicationDetail>;
  taskApplicationDetails: Array<TaskApplicationDetail>;
  taskAssignmentDetail?: Maybe<TaskAssignmentDetail>;
  taskAssignmentDetails: Array<TaskAssignmentDetail>;
  taskCancellationDetail?: Maybe<TaskCancellationDetail>;
  taskCancellationDetails: Array<TaskCancellationDetail>;
  taskCompletionDetail?: Maybe<TaskCompletionDetail>;
  taskCompletionDetails: Array<TaskCompletionDetail>;
  taskCreationDetail?: Maybe<TaskCreationDetail>;
  taskCreationDetails: Array<TaskCreationDetail>;
  taskSubmissionDetail?: Maybe<TaskSubmissionDetail>;
  taskSubmissionDetails: Array<TaskSubmissionDetail>;
  taskTimelineDetail?: Maybe<TaskTimelineDetail>;
  taskTimelineDetails: Array<TaskTimelineDetail>;
  tasks: Array<Task>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryDisputeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDisputeRaiseDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDisputeRaiseDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DisputeRaiseDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DisputeRaiseDetail_Filter>;
};


export type QueryDisputeResolutionDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDisputeResolutionDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DisputeResolutionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DisputeResolutionDetail_Filter>;
};


export type QueryDisputesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Dispute_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Dispute_Filter>;
};


export type QueryGlobalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryGlobalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Global_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Global_Filter>;
};


export type QueryTaskArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskApplicationDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskApplicationDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskApplicationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskApplicationDetail_Filter>;
};


export type QueryTaskAssignmentDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskAssignmentDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskAssignmentDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskAssignmentDetail_Filter>;
};


export type QueryTaskCancellationDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskCancellationDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskCancellationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskCancellationDetail_Filter>;
};


export type QueryTaskCompletionDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskCompletionDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskCompletionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskCompletionDetail_Filter>;
};


export type QueryTaskCreationDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskCreationDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskCreationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskCreationDetail_Filter>;
};


export type QueryTaskSubmissionDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskSubmissionDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskSubmissionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskSubmissionDetail_Filter>;
};


export type QueryTaskTimelineDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTaskTimelineDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskTimelineDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskTimelineDetail_Filter>;
};


export type QueryTasksArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Task_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Task_Filter>;
};


export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};

export enum ResolutionStatus {
  Cancel = 'cancel',
  Complete = 'complete'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dispute?: Maybe<Dispute>;
  disputeRaiseDetail?: Maybe<DisputeRaiseDetail>;
  disputeRaiseDetails: Array<DisputeRaiseDetail>;
  disputeResolutionDetail?: Maybe<DisputeResolutionDetail>;
  disputeResolutionDetails: Array<DisputeResolutionDetail>;
  disputes: Array<Dispute>;
  global?: Maybe<Global>;
  globals: Array<Global>;
  task?: Maybe<Task>;
  taskApplicationDetail?: Maybe<TaskApplicationDetail>;
  taskApplicationDetails: Array<TaskApplicationDetail>;
  taskAssignmentDetail?: Maybe<TaskAssignmentDetail>;
  taskAssignmentDetails: Array<TaskAssignmentDetail>;
  taskCancellationDetail?: Maybe<TaskCancellationDetail>;
  taskCancellationDetails: Array<TaskCancellationDetail>;
  taskCompletionDetail?: Maybe<TaskCompletionDetail>;
  taskCompletionDetails: Array<TaskCompletionDetail>;
  taskCreationDetail?: Maybe<TaskCreationDetail>;
  taskCreationDetails: Array<TaskCreationDetail>;
  taskSubmissionDetail?: Maybe<TaskSubmissionDetail>;
  taskSubmissionDetails: Array<TaskSubmissionDetail>;
  taskTimelineDetail?: Maybe<TaskTimelineDetail>;
  taskTimelineDetails: Array<TaskTimelineDetail>;
  tasks: Array<Task>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionDisputeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDisputeRaiseDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDisputeRaiseDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DisputeRaiseDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DisputeRaiseDetail_Filter>;
};


export type SubscriptionDisputeResolutionDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDisputeResolutionDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DisputeResolutionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DisputeResolutionDetail_Filter>;
};


export type SubscriptionDisputesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Dispute_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Dispute_Filter>;
};


export type SubscriptionGlobalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionGlobalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Global_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Global_Filter>;
};


export type SubscriptionTaskArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskApplicationDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskApplicationDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskApplicationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskApplicationDetail_Filter>;
};


export type SubscriptionTaskAssignmentDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskAssignmentDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskAssignmentDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskAssignmentDetail_Filter>;
};


export type SubscriptionTaskCancellationDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskCancellationDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskCancellationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskCancellationDetail_Filter>;
};


export type SubscriptionTaskCompletionDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskCompletionDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskCompletionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskCompletionDetail_Filter>;
};


export type SubscriptionTaskCreationDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskCreationDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskCreationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskCreationDetail_Filter>;
};


export type SubscriptionTaskSubmissionDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskSubmissionDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskSubmissionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskSubmissionDetail_Filter>;
};


export type SubscriptionTaskTimelineDetailArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTaskTimelineDetailsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskTimelineDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TaskTimelineDetail_Filter>;
};


export type SubscriptionTasksArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Task_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Task_Filter>;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type SubscriptionUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};

export type Task = {
  __typename?: 'Task';
  amount: Scalars['BigInt'];
  assignmentDetail?: Maybe<TaskAssignmentDetail>;
  assignmentDetailUri?: Maybe<Scalars['String']>;
  cancellationDetail?: Maybe<TaskCancellationDetail>;
  cancellationDetailUri?: Maybe<Scalars['String']>;
  completionDetail?: Maybe<TaskCompletionDetail>;
  completionDetailUri?: Maybe<Scalars['String']>;
  contributor?: Maybe<User>;
  createdAt: Scalars['BigInt'];
  creationDetail: TaskCreationDetail;
  creationDetailUri: Scalars['String'];
  dispute: Dispute;
  escrowAddress: Scalars['Bytes'];
  fee: Scalars['BigInt'];
  id: Scalars['ID'];
  reviewer: User;
  status: TaskStatus;
  taskId: Scalars['BigInt'];
  token: Token;
};

export type TaskApplicationDetail = {
  __typename?: 'TaskApplicationDetail';
  address?: Maybe<Scalars['Bytes']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  task: Task;
  timestamp?: Maybe<Scalars['BigDecimal']>;
};

export type TaskApplicationDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  message?: InputMaybe<Scalars['String']>;
  message_contains?: InputMaybe<Scalars['String']>;
  message_contains_nocase?: InputMaybe<Scalars['String']>;
  message_ends_with?: InputMaybe<Scalars['String']>;
  message_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_gt?: InputMaybe<Scalars['String']>;
  message_gte?: InputMaybe<Scalars['String']>;
  message_in?: InputMaybe<Array<Scalars['String']>>;
  message_lt?: InputMaybe<Scalars['String']>;
  message_lte?: InputMaybe<Scalars['String']>;
  message_not?: InputMaybe<Scalars['String']>;
  message_not_contains?: InputMaybe<Scalars['String']>;
  message_not_contains_nocase?: InputMaybe<Scalars['String']>;
  message_not_ends_with?: InputMaybe<Scalars['String']>;
  message_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_not_in?: InputMaybe<Array<Scalars['String']>>;
  message_not_starts_with?: InputMaybe<Scalars['String']>;
  message_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  message_starts_with?: InputMaybe<Scalars['String']>;
  message_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_gt?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_gte?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  timestamp_lt?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_lte?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_not?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
};

export enum TaskApplicationDetail_OrderBy {
  Address = 'address',
  Id = 'id',
  Message = 'message',
  Task = 'task',
  Timestamp = 'timestamp'
}

export type TaskAssignmentDetail = {
  __typename?: 'TaskAssignmentDetail';
  applications?: Maybe<Array<TaskApplicationDetail>>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  task: Task;
};


export type TaskAssignmentDetailApplicationsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskApplicationDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskApplicationDetail_Filter>;
};

export type TaskAssignmentDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  applications?: InputMaybe<Array<Scalars['String']>>;
  applications_?: InputMaybe<TaskApplicationDetail_Filter>;
  applications_contains?: InputMaybe<Array<Scalars['String']>>;
  applications_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  applications_not?: InputMaybe<Array<Scalars['String']>>;
  applications_not_contains?: InputMaybe<Array<Scalars['String']>>;
  applications_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  message?: InputMaybe<Scalars['String']>;
  message_contains?: InputMaybe<Scalars['String']>;
  message_contains_nocase?: InputMaybe<Scalars['String']>;
  message_ends_with?: InputMaybe<Scalars['String']>;
  message_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_gt?: InputMaybe<Scalars['String']>;
  message_gte?: InputMaybe<Scalars['String']>;
  message_in?: InputMaybe<Array<Scalars['String']>>;
  message_lt?: InputMaybe<Scalars['String']>;
  message_lte?: InputMaybe<Scalars['String']>;
  message_not?: InputMaybe<Scalars['String']>;
  message_not_contains?: InputMaybe<Scalars['String']>;
  message_not_contains_nocase?: InputMaybe<Scalars['String']>;
  message_not_ends_with?: InputMaybe<Scalars['String']>;
  message_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_not_in?: InputMaybe<Array<Scalars['String']>>;
  message_not_starts_with?: InputMaybe<Scalars['String']>;
  message_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  message_starts_with?: InputMaybe<Scalars['String']>;
  message_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum TaskAssignmentDetail_OrderBy {
  Applications = 'applications',
  Id = 'id',
  Message = 'message',
  Task = 'task'
}

export type TaskCancellationDetail = {
  __typename?: 'TaskCancellationDetail';
  cancellationReason?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  submissions?: Maybe<Array<TaskSubmissionDetail>>;
  task: Task;
};


export type TaskCancellationDetailSubmissionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskSubmissionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskSubmissionDetail_Filter>;
};

export type TaskCancellationDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationReason_contains?: InputMaybe<Scalars['String']>;
  cancellationReason_contains_nocase?: InputMaybe<Scalars['String']>;
  cancellationReason_ends_with?: InputMaybe<Scalars['String']>;
  cancellationReason_ends_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationReason_gt?: InputMaybe<Scalars['String']>;
  cancellationReason_gte?: InputMaybe<Scalars['String']>;
  cancellationReason_in?: InputMaybe<Array<Scalars['String']>>;
  cancellationReason_lt?: InputMaybe<Scalars['String']>;
  cancellationReason_lte?: InputMaybe<Scalars['String']>;
  cancellationReason_not?: InputMaybe<Scalars['String']>;
  cancellationReason_not_contains?: InputMaybe<Scalars['String']>;
  cancellationReason_not_contains_nocase?: InputMaybe<Scalars['String']>;
  cancellationReason_not_ends_with?: InputMaybe<Scalars['String']>;
  cancellationReason_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationReason_not_in?: InputMaybe<Array<Scalars['String']>>;
  cancellationReason_not_starts_with?: InputMaybe<Scalars['String']>;
  cancellationReason_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationReason_starts_with?: InputMaybe<Scalars['String']>;
  cancellationReason_starts_with_nocase?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  comment_contains?: InputMaybe<Scalars['String']>;
  comment_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_ends_with?: InputMaybe<Scalars['String']>;
  comment_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_gt?: InputMaybe<Scalars['String']>;
  comment_gte?: InputMaybe<Scalars['String']>;
  comment_in?: InputMaybe<Array<Scalars['String']>>;
  comment_lt?: InputMaybe<Scalars['String']>;
  comment_lte?: InputMaybe<Scalars['String']>;
  comment_not?: InputMaybe<Scalars['String']>;
  comment_not_contains?: InputMaybe<Scalars['String']>;
  comment_not_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_not_ends_with?: InputMaybe<Scalars['String']>;
  comment_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_not_in?: InputMaybe<Array<Scalars['String']>>;
  comment_not_starts_with?: InputMaybe<Scalars['String']>;
  comment_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  comment_starts_with?: InputMaybe<Scalars['String']>;
  comment_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  submissions?: InputMaybe<Array<Scalars['String']>>;
  submissions_?: InputMaybe<TaskSubmissionDetail_Filter>;
  submissions_contains?: InputMaybe<Array<Scalars['String']>>;
  submissions_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  submissions_not?: InputMaybe<Array<Scalars['String']>>;
  submissions_not_contains?: InputMaybe<Array<Scalars['String']>>;
  submissions_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum TaskCancellationDetail_OrderBy {
  CancellationReason = 'cancellationReason',
  Comment = 'comment',
  Id = 'id',
  Submissions = 'submissions',
  Task = 'task'
}

export type TaskCompletionDetail = {
  __typename?: 'TaskCompletionDetail';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  submissions?: Maybe<Array<TaskSubmissionDetail>>;
  task: Task;
  timeline?: Maybe<Array<TaskTimelineDetail>>;
};


export type TaskCompletionDetailSubmissionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskSubmissionDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskSubmissionDetail_Filter>;
};


export type TaskCompletionDetailTimelineArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TaskTimelineDetail_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskTimelineDetail_Filter>;
};

export type TaskCompletionDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  comment?: InputMaybe<Scalars['String']>;
  comment_contains?: InputMaybe<Scalars['String']>;
  comment_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_ends_with?: InputMaybe<Scalars['String']>;
  comment_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_gt?: InputMaybe<Scalars['String']>;
  comment_gte?: InputMaybe<Scalars['String']>;
  comment_in?: InputMaybe<Array<Scalars['String']>>;
  comment_lt?: InputMaybe<Scalars['String']>;
  comment_lte?: InputMaybe<Scalars['String']>;
  comment_not?: InputMaybe<Scalars['String']>;
  comment_not_contains?: InputMaybe<Scalars['String']>;
  comment_not_contains_nocase?: InputMaybe<Scalars['String']>;
  comment_not_ends_with?: InputMaybe<Scalars['String']>;
  comment_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  comment_not_in?: InputMaybe<Array<Scalars['String']>>;
  comment_not_starts_with?: InputMaybe<Scalars['String']>;
  comment_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  comment_starts_with?: InputMaybe<Scalars['String']>;
  comment_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  submissions?: InputMaybe<Array<Scalars['String']>>;
  submissions_?: InputMaybe<TaskSubmissionDetail_Filter>;
  submissions_contains?: InputMaybe<Array<Scalars['String']>>;
  submissions_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  submissions_not?: InputMaybe<Array<Scalars['String']>>;
  submissions_not_contains?: InputMaybe<Array<Scalars['String']>>;
  submissions_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timeline?: InputMaybe<Array<Scalars['String']>>;
  timeline_?: InputMaybe<TaskTimelineDetail_Filter>;
  timeline_contains?: InputMaybe<Array<Scalars['String']>>;
  timeline_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  timeline_not?: InputMaybe<Array<Scalars['String']>>;
  timeline_not_contains?: InputMaybe<Array<Scalars['String']>>;
  timeline_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
};

export enum TaskCompletionDetail_OrderBy {
  Comment = 'comment',
  Id = 'id',
  Submissions = 'submissions',
  Task = 'task',
  Timeline = 'timeline'
}

export type TaskCreationDetail = {
  __typename?: 'TaskCreationDetail';
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['BigDecimal']>;
  description?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  tags?: Maybe<Array<Scalars['String']>>;
  task: Task;
  timeEstimateUnit?: Maybe<Scalars['String']>;
  timeEstimateValue?: Maybe<Scalars['BigDecimal']>;
  title?: Maybe<Scalars['String']>;
};

export type TaskCreationDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  category?: InputMaybe<Scalars['String']>;
  category_contains?: InputMaybe<Scalars['String']>;
  category_contains_nocase?: InputMaybe<Scalars['String']>;
  category_ends_with?: InputMaybe<Scalars['String']>;
  category_ends_with_nocase?: InputMaybe<Scalars['String']>;
  category_gt?: InputMaybe<Scalars['String']>;
  category_gte?: InputMaybe<Scalars['String']>;
  category_in?: InputMaybe<Array<Scalars['String']>>;
  category_lt?: InputMaybe<Scalars['String']>;
  category_lte?: InputMaybe<Scalars['String']>;
  category_not?: InputMaybe<Scalars['String']>;
  category_not_contains?: InputMaybe<Scalars['String']>;
  category_not_contains_nocase?: InputMaybe<Scalars['String']>;
  category_not_ends_with?: InputMaybe<Scalars['String']>;
  category_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  category_not_in?: InputMaybe<Array<Scalars['String']>>;
  category_not_starts_with?: InputMaybe<Scalars['String']>;
  category_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  category_starts_with?: InputMaybe<Scalars['String']>;
  category_starts_with_nocase?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  content_contains?: InputMaybe<Scalars['String']>;
  content_contains_nocase?: InputMaybe<Scalars['String']>;
  content_ends_with?: InputMaybe<Scalars['String']>;
  content_ends_with_nocase?: InputMaybe<Scalars['String']>;
  content_gt?: InputMaybe<Scalars['String']>;
  content_gte?: InputMaybe<Scalars['String']>;
  content_in?: InputMaybe<Array<Scalars['String']>>;
  content_lt?: InputMaybe<Scalars['String']>;
  content_lte?: InputMaybe<Scalars['String']>;
  content_not?: InputMaybe<Scalars['String']>;
  content_not_contains?: InputMaybe<Scalars['String']>;
  content_not_contains_nocase?: InputMaybe<Scalars['String']>;
  content_not_ends_with?: InputMaybe<Scalars['String']>;
  content_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  content_not_in?: InputMaybe<Array<Scalars['String']>>;
  content_not_starts_with?: InputMaybe<Scalars['String']>;
  content_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  content_starts_with?: InputMaybe<Scalars['String']>;
  content_starts_with_nocase?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['BigDecimal']>;
  deadline_gt?: InputMaybe<Scalars['BigDecimal']>;
  deadline_gte?: InputMaybe<Scalars['BigDecimal']>;
  deadline_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  deadline_lt?: InputMaybe<Scalars['BigDecimal']>;
  deadline_lte?: InputMaybe<Scalars['BigDecimal']>;
  deadline_not?: InputMaybe<Scalars['BigDecimal']>;
  deadline_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_contains_nocase?: InputMaybe<Scalars['String']>;
  description_ends_with?: InputMaybe<Scalars['String']>;
  description_ends_with_nocase?: InputMaybe<Scalars['String']>;
  description_gt?: InputMaybe<Scalars['String']>;
  description_gte?: InputMaybe<Scalars['String']>;
  description_in?: InputMaybe<Array<Scalars['String']>>;
  description_lt?: InputMaybe<Scalars['String']>;
  description_lte?: InputMaybe<Scalars['String']>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_contains_nocase?: InputMaybe<Scalars['String']>;
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  description_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<Scalars['String']>>;
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  description_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  description_starts_with?: InputMaybe<Scalars['String']>;
  description_starts_with_nocase?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Scalars['String']>;
  experience_contains?: InputMaybe<Scalars['String']>;
  experience_contains_nocase?: InputMaybe<Scalars['String']>;
  experience_ends_with?: InputMaybe<Scalars['String']>;
  experience_ends_with_nocase?: InputMaybe<Scalars['String']>;
  experience_gt?: InputMaybe<Scalars['String']>;
  experience_gte?: InputMaybe<Scalars['String']>;
  experience_in?: InputMaybe<Array<Scalars['String']>>;
  experience_lt?: InputMaybe<Scalars['String']>;
  experience_lte?: InputMaybe<Scalars['String']>;
  experience_not?: InputMaybe<Scalars['String']>;
  experience_not_contains?: InputMaybe<Scalars['String']>;
  experience_not_contains_nocase?: InputMaybe<Scalars['String']>;
  experience_not_ends_with?: InputMaybe<Scalars['String']>;
  experience_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  experience_not_in?: InputMaybe<Array<Scalars['String']>>;
  experience_not_starts_with?: InputMaybe<Scalars['String']>;
  experience_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  experience_starts_with?: InputMaybe<Scalars['String']>;
  experience_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tags_contains?: InputMaybe<Array<Scalars['String']>>;
  tags_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  tags_not?: InputMaybe<Array<Scalars['String']>>;
  tags_not_contains?: InputMaybe<Array<Scalars['String']>>;
  tags_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateUnit?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_contains?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_contains_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_ends_with?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_ends_with_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_gt?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_gte?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_in?: InputMaybe<Array<Scalars['String']>>;
  timeEstimateUnit_lt?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_lte?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not_contains?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not_contains_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not_ends_with?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not_in?: InputMaybe<Array<Scalars['String']>>;
  timeEstimateUnit_not_starts_with?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_starts_with?: InputMaybe<Scalars['String']>;
  timeEstimateUnit_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timeEstimateValue?: InputMaybe<Scalars['BigDecimal']>;
  timeEstimateValue_gt?: InputMaybe<Scalars['BigDecimal']>;
  timeEstimateValue_gte?: InputMaybe<Scalars['BigDecimal']>;
  timeEstimateValue_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  timeEstimateValue_lt?: InputMaybe<Scalars['BigDecimal']>;
  timeEstimateValue_lte?: InputMaybe<Scalars['BigDecimal']>;
  timeEstimateValue_not?: InputMaybe<Scalars['BigDecimal']>;
  timeEstimateValue_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_contains_nocase?: InputMaybe<Scalars['String']>;
  title_ends_with?: InputMaybe<Scalars['String']>;
  title_ends_with_nocase?: InputMaybe<Scalars['String']>;
  title_gt?: InputMaybe<Scalars['String']>;
  title_gte?: InputMaybe<Scalars['String']>;
  title_in?: InputMaybe<Array<Scalars['String']>>;
  title_lt?: InputMaybe<Scalars['String']>;
  title_lte?: InputMaybe<Scalars['String']>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_contains_nocase?: InputMaybe<Scalars['String']>;
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  title_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<Scalars['String']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  title_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  title_starts_with?: InputMaybe<Scalars['String']>;
  title_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum TaskCreationDetail_OrderBy {
  Category = 'category',
  Content = 'content',
  Deadline = 'deadline',
  Description = 'description',
  Experience = 'experience',
  Id = 'id',
  Tags = 'tags',
  Task = 'task',
  TimeEstimateUnit = 'timeEstimateUnit',
  TimeEstimateValue = 'timeEstimateValue',
  Title = 'title'
}

export enum TaskStatus {
  Active = 'active',
  Cancel = 'cancel',
  Complete = 'complete',
  Inactive = 'inactive',
  Indispute = 'indispute',
  None = 'none'
}

export type TaskSubmissionDetail = {
  __typename?: 'TaskSubmissionDetail';
  attachments?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  task: Task;
  timestamp?: Maybe<Scalars['BigDecimal']>;
};

export type TaskSubmissionDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  attachments?: InputMaybe<Array<Scalars['String']>>;
  attachments_contains?: InputMaybe<Array<Scalars['String']>>;
  attachments_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  attachments_not?: InputMaybe<Array<Scalars['String']>>;
  attachments_not_contains?: InputMaybe<Array<Scalars['String']>>;
  attachments_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  message?: InputMaybe<Scalars['String']>;
  message_contains?: InputMaybe<Scalars['String']>;
  message_contains_nocase?: InputMaybe<Scalars['String']>;
  message_ends_with?: InputMaybe<Scalars['String']>;
  message_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_gt?: InputMaybe<Scalars['String']>;
  message_gte?: InputMaybe<Scalars['String']>;
  message_in?: InputMaybe<Array<Scalars['String']>>;
  message_lt?: InputMaybe<Scalars['String']>;
  message_lte?: InputMaybe<Scalars['String']>;
  message_not?: InputMaybe<Scalars['String']>;
  message_not_contains?: InputMaybe<Scalars['String']>;
  message_not_contains_nocase?: InputMaybe<Scalars['String']>;
  message_not_ends_with?: InputMaybe<Scalars['String']>;
  message_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_not_in?: InputMaybe<Array<Scalars['String']>>;
  message_not_starts_with?: InputMaybe<Scalars['String']>;
  message_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  message_starts_with?: InputMaybe<Scalars['String']>;
  message_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_gt?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_gte?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  timestamp_lt?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_lte?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_not?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
};

export enum TaskSubmissionDetail_OrderBy {
  Attachments = 'attachments',
  Id = 'id',
  Message = 'message',
  Task = 'task',
  Timestamp = 'timestamp'
}

export type TaskTimelineDetail = {
  __typename?: 'TaskTimelineDetail';
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  task: Task;
  timestamp?: Maybe<Scalars['BigDecimal']>;
};

export type TaskTimelineDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  kind?: InputMaybe<Scalars['String']>;
  kind_contains?: InputMaybe<Scalars['String']>;
  kind_contains_nocase?: InputMaybe<Scalars['String']>;
  kind_ends_with?: InputMaybe<Scalars['String']>;
  kind_ends_with_nocase?: InputMaybe<Scalars['String']>;
  kind_gt?: InputMaybe<Scalars['String']>;
  kind_gte?: InputMaybe<Scalars['String']>;
  kind_in?: InputMaybe<Array<Scalars['String']>>;
  kind_lt?: InputMaybe<Scalars['String']>;
  kind_lte?: InputMaybe<Scalars['String']>;
  kind_not?: InputMaybe<Scalars['String']>;
  kind_not_contains?: InputMaybe<Scalars['String']>;
  kind_not_contains_nocase?: InputMaybe<Scalars['String']>;
  kind_not_ends_with?: InputMaybe<Scalars['String']>;
  kind_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  kind_not_in?: InputMaybe<Array<Scalars['String']>>;
  kind_not_starts_with?: InputMaybe<Scalars['String']>;
  kind_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  kind_starts_with?: InputMaybe<Scalars['String']>;
  kind_starts_with_nocase?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  message_contains?: InputMaybe<Scalars['String']>;
  message_contains_nocase?: InputMaybe<Scalars['String']>;
  message_ends_with?: InputMaybe<Scalars['String']>;
  message_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_gt?: InputMaybe<Scalars['String']>;
  message_gte?: InputMaybe<Scalars['String']>;
  message_in?: InputMaybe<Array<Scalars['String']>>;
  message_lt?: InputMaybe<Scalars['String']>;
  message_lte?: InputMaybe<Scalars['String']>;
  message_not?: InputMaybe<Scalars['String']>;
  message_not_contains?: InputMaybe<Scalars['String']>;
  message_not_contains_nocase?: InputMaybe<Scalars['String']>;
  message_not_ends_with?: InputMaybe<Scalars['String']>;
  message_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  message_not_in?: InputMaybe<Array<Scalars['String']>>;
  message_not_starts_with?: InputMaybe<Scalars['String']>;
  message_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  message_starts_with?: InputMaybe<Scalars['String']>;
  message_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task?: InputMaybe<Scalars['String']>;
  task_?: InputMaybe<Task_Filter>;
  task_contains?: InputMaybe<Scalars['String']>;
  task_contains_nocase?: InputMaybe<Scalars['String']>;
  task_ends_with?: InputMaybe<Scalars['String']>;
  task_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_gt?: InputMaybe<Scalars['String']>;
  task_gte?: InputMaybe<Scalars['String']>;
  task_in?: InputMaybe<Array<Scalars['String']>>;
  task_lt?: InputMaybe<Scalars['String']>;
  task_lte?: InputMaybe<Scalars['String']>;
  task_not?: InputMaybe<Scalars['String']>;
  task_not_contains?: InputMaybe<Scalars['String']>;
  task_not_contains_nocase?: InputMaybe<Scalars['String']>;
  task_not_ends_with?: InputMaybe<Scalars['String']>;
  task_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  task_not_in?: InputMaybe<Array<Scalars['String']>>;
  task_not_starts_with?: InputMaybe<Scalars['String']>;
  task_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  task_starts_with?: InputMaybe<Scalars['String']>;
  task_starts_with_nocase?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_gt?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_gte?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  timestamp_lt?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_lte?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_not?: InputMaybe<Scalars['BigDecimal']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
};

export enum TaskTimelineDetail_OrderBy {
  Id = 'id',
  Kind = 'kind',
  Message = 'message',
  Task = 'task',
  Timestamp = 'timestamp'
}

export type Task_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  assignmentDetail?: InputMaybe<Scalars['String']>;
  assignmentDetailUri?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_contains?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_contains_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_ends_with?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_ends_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_gt?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_gte?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_in?: InputMaybe<Array<Scalars['String']>>;
  assignmentDetailUri_lt?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_lte?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not_contains?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not_contains_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not_ends_with?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not_in?: InputMaybe<Array<Scalars['String']>>;
  assignmentDetailUri_not_starts_with?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_starts_with?: InputMaybe<Scalars['String']>;
  assignmentDetailUri_starts_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetail_?: InputMaybe<TaskAssignmentDetail_Filter>;
  assignmentDetail_contains?: InputMaybe<Scalars['String']>;
  assignmentDetail_contains_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetail_ends_with?: InputMaybe<Scalars['String']>;
  assignmentDetail_ends_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetail_gt?: InputMaybe<Scalars['String']>;
  assignmentDetail_gte?: InputMaybe<Scalars['String']>;
  assignmentDetail_in?: InputMaybe<Array<Scalars['String']>>;
  assignmentDetail_lt?: InputMaybe<Scalars['String']>;
  assignmentDetail_lte?: InputMaybe<Scalars['String']>;
  assignmentDetail_not?: InputMaybe<Scalars['String']>;
  assignmentDetail_not_contains?: InputMaybe<Scalars['String']>;
  assignmentDetail_not_contains_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetail_not_ends_with?: InputMaybe<Scalars['String']>;
  assignmentDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetail_not_in?: InputMaybe<Array<Scalars['String']>>;
  assignmentDetail_not_starts_with?: InputMaybe<Scalars['String']>;
  assignmentDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  assignmentDetail_starts_with?: InputMaybe<Scalars['String']>;
  assignmentDetail_starts_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail?: InputMaybe<Scalars['String']>;
  cancellationDetailUri?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_contains?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_contains_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_ends_with?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_ends_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_gt?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_gte?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_in?: InputMaybe<Array<Scalars['String']>>;
  cancellationDetailUri_lt?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_lte?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not_contains?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not_contains_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not_ends_with?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not_in?: InputMaybe<Array<Scalars['String']>>;
  cancellationDetailUri_not_starts_with?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_starts_with?: InputMaybe<Scalars['String']>;
  cancellationDetailUri_starts_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail_?: InputMaybe<TaskCancellationDetail_Filter>;
  cancellationDetail_contains?: InputMaybe<Scalars['String']>;
  cancellationDetail_contains_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail_ends_with?: InputMaybe<Scalars['String']>;
  cancellationDetail_ends_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail_gt?: InputMaybe<Scalars['String']>;
  cancellationDetail_gte?: InputMaybe<Scalars['String']>;
  cancellationDetail_in?: InputMaybe<Array<Scalars['String']>>;
  cancellationDetail_lt?: InputMaybe<Scalars['String']>;
  cancellationDetail_lte?: InputMaybe<Scalars['String']>;
  cancellationDetail_not?: InputMaybe<Scalars['String']>;
  cancellationDetail_not_contains?: InputMaybe<Scalars['String']>;
  cancellationDetail_not_contains_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail_not_ends_with?: InputMaybe<Scalars['String']>;
  cancellationDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail_not_in?: InputMaybe<Array<Scalars['String']>>;
  cancellationDetail_not_starts_with?: InputMaybe<Scalars['String']>;
  cancellationDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  cancellationDetail_starts_with?: InputMaybe<Scalars['String']>;
  cancellationDetail_starts_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetail?: InputMaybe<Scalars['String']>;
  completionDetailUri?: InputMaybe<Scalars['String']>;
  completionDetailUri_contains?: InputMaybe<Scalars['String']>;
  completionDetailUri_contains_nocase?: InputMaybe<Scalars['String']>;
  completionDetailUri_ends_with?: InputMaybe<Scalars['String']>;
  completionDetailUri_ends_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetailUri_gt?: InputMaybe<Scalars['String']>;
  completionDetailUri_gte?: InputMaybe<Scalars['String']>;
  completionDetailUri_in?: InputMaybe<Array<Scalars['String']>>;
  completionDetailUri_lt?: InputMaybe<Scalars['String']>;
  completionDetailUri_lte?: InputMaybe<Scalars['String']>;
  completionDetailUri_not?: InputMaybe<Scalars['String']>;
  completionDetailUri_not_contains?: InputMaybe<Scalars['String']>;
  completionDetailUri_not_contains_nocase?: InputMaybe<Scalars['String']>;
  completionDetailUri_not_ends_with?: InputMaybe<Scalars['String']>;
  completionDetailUri_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetailUri_not_in?: InputMaybe<Array<Scalars['String']>>;
  completionDetailUri_not_starts_with?: InputMaybe<Scalars['String']>;
  completionDetailUri_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetailUri_starts_with?: InputMaybe<Scalars['String']>;
  completionDetailUri_starts_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetail_?: InputMaybe<TaskCompletionDetail_Filter>;
  completionDetail_contains?: InputMaybe<Scalars['String']>;
  completionDetail_contains_nocase?: InputMaybe<Scalars['String']>;
  completionDetail_ends_with?: InputMaybe<Scalars['String']>;
  completionDetail_ends_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetail_gt?: InputMaybe<Scalars['String']>;
  completionDetail_gte?: InputMaybe<Scalars['String']>;
  completionDetail_in?: InputMaybe<Array<Scalars['String']>>;
  completionDetail_lt?: InputMaybe<Scalars['String']>;
  completionDetail_lte?: InputMaybe<Scalars['String']>;
  completionDetail_not?: InputMaybe<Scalars['String']>;
  completionDetail_not_contains?: InputMaybe<Scalars['String']>;
  completionDetail_not_contains_nocase?: InputMaybe<Scalars['String']>;
  completionDetail_not_ends_with?: InputMaybe<Scalars['String']>;
  completionDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetail_not_in?: InputMaybe<Array<Scalars['String']>>;
  completionDetail_not_starts_with?: InputMaybe<Scalars['String']>;
  completionDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  completionDetail_starts_with?: InputMaybe<Scalars['String']>;
  completionDetail_starts_with_nocase?: InputMaybe<Scalars['String']>;
  contributor?: InputMaybe<Scalars['String']>;
  contributor_?: InputMaybe<User_Filter>;
  contributor_contains?: InputMaybe<Scalars['String']>;
  contributor_contains_nocase?: InputMaybe<Scalars['String']>;
  contributor_ends_with?: InputMaybe<Scalars['String']>;
  contributor_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contributor_gt?: InputMaybe<Scalars['String']>;
  contributor_gte?: InputMaybe<Scalars['String']>;
  contributor_in?: InputMaybe<Array<Scalars['String']>>;
  contributor_lt?: InputMaybe<Scalars['String']>;
  contributor_lte?: InputMaybe<Scalars['String']>;
  contributor_not?: InputMaybe<Scalars['String']>;
  contributor_not_contains?: InputMaybe<Scalars['String']>;
  contributor_not_contains_nocase?: InputMaybe<Scalars['String']>;
  contributor_not_ends_with?: InputMaybe<Scalars['String']>;
  contributor_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contributor_not_in?: InputMaybe<Array<Scalars['String']>>;
  contributor_not_starts_with?: InputMaybe<Scalars['String']>;
  contributor_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  contributor_starts_with?: InputMaybe<Scalars['String']>;
  contributor_starts_with_nocase?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['BigInt']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  creationDetail?: InputMaybe<Scalars['String']>;
  creationDetailUri?: InputMaybe<Scalars['String']>;
  creationDetailUri_contains?: InputMaybe<Scalars['String']>;
  creationDetailUri_contains_nocase?: InputMaybe<Scalars['String']>;
  creationDetailUri_ends_with?: InputMaybe<Scalars['String']>;
  creationDetailUri_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetailUri_gt?: InputMaybe<Scalars['String']>;
  creationDetailUri_gte?: InputMaybe<Scalars['String']>;
  creationDetailUri_in?: InputMaybe<Array<Scalars['String']>>;
  creationDetailUri_lt?: InputMaybe<Scalars['String']>;
  creationDetailUri_lte?: InputMaybe<Scalars['String']>;
  creationDetailUri_not?: InputMaybe<Scalars['String']>;
  creationDetailUri_not_contains?: InputMaybe<Scalars['String']>;
  creationDetailUri_not_contains_nocase?: InputMaybe<Scalars['String']>;
  creationDetailUri_not_ends_with?: InputMaybe<Scalars['String']>;
  creationDetailUri_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetailUri_not_in?: InputMaybe<Array<Scalars['String']>>;
  creationDetailUri_not_starts_with?: InputMaybe<Scalars['String']>;
  creationDetailUri_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetailUri_starts_with?: InputMaybe<Scalars['String']>;
  creationDetailUri_starts_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetail_?: InputMaybe<TaskCreationDetail_Filter>;
  creationDetail_contains?: InputMaybe<Scalars['String']>;
  creationDetail_contains_nocase?: InputMaybe<Scalars['String']>;
  creationDetail_ends_with?: InputMaybe<Scalars['String']>;
  creationDetail_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetail_gt?: InputMaybe<Scalars['String']>;
  creationDetail_gte?: InputMaybe<Scalars['String']>;
  creationDetail_in?: InputMaybe<Array<Scalars['String']>>;
  creationDetail_lt?: InputMaybe<Scalars['String']>;
  creationDetail_lte?: InputMaybe<Scalars['String']>;
  creationDetail_not?: InputMaybe<Scalars['String']>;
  creationDetail_not_contains?: InputMaybe<Scalars['String']>;
  creationDetail_not_contains_nocase?: InputMaybe<Scalars['String']>;
  creationDetail_not_ends_with?: InputMaybe<Scalars['String']>;
  creationDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetail_not_in?: InputMaybe<Array<Scalars['String']>>;
  creationDetail_not_starts_with?: InputMaybe<Scalars['String']>;
  creationDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  creationDetail_starts_with?: InputMaybe<Scalars['String']>;
  creationDetail_starts_with_nocase?: InputMaybe<Scalars['String']>;
  dispute_?: InputMaybe<Dispute_Filter>;
  escrowAddress?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_contains?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  escrowAddress_not?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  escrowAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  fee?: InputMaybe<Scalars['BigInt']>;
  fee_gt?: InputMaybe<Scalars['BigInt']>;
  fee_gte?: InputMaybe<Scalars['BigInt']>;
  fee_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fee_lt?: InputMaybe<Scalars['BigInt']>;
  fee_lte?: InputMaybe<Scalars['BigInt']>;
  fee_not?: InputMaybe<Scalars['BigInt']>;
  fee_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  reviewer?: InputMaybe<Scalars['String']>;
  reviewer_?: InputMaybe<User_Filter>;
  reviewer_contains?: InputMaybe<Scalars['String']>;
  reviewer_contains_nocase?: InputMaybe<Scalars['String']>;
  reviewer_ends_with?: InputMaybe<Scalars['String']>;
  reviewer_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reviewer_gt?: InputMaybe<Scalars['String']>;
  reviewer_gte?: InputMaybe<Scalars['String']>;
  reviewer_in?: InputMaybe<Array<Scalars['String']>>;
  reviewer_lt?: InputMaybe<Scalars['String']>;
  reviewer_lte?: InputMaybe<Scalars['String']>;
  reviewer_not?: InputMaybe<Scalars['String']>;
  reviewer_not_contains?: InputMaybe<Scalars['String']>;
  reviewer_not_contains_nocase?: InputMaybe<Scalars['String']>;
  reviewer_not_ends_with?: InputMaybe<Scalars['String']>;
  reviewer_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reviewer_not_in?: InputMaybe<Array<Scalars['String']>>;
  reviewer_not_starts_with?: InputMaybe<Scalars['String']>;
  reviewer_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reviewer_starts_with?: InputMaybe<Scalars['String']>;
  reviewer_starts_with_nocase?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatus>;
  status_in?: InputMaybe<Array<TaskStatus>>;
  status_not?: InputMaybe<TaskStatus>;
  status_not_in?: InputMaybe<Array<TaskStatus>>;
  taskId?: InputMaybe<Scalars['BigInt']>;
  taskId_gt?: InputMaybe<Scalars['BigInt']>;
  taskId_gte?: InputMaybe<Scalars['BigInt']>;
  taskId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  taskId_lt?: InputMaybe<Scalars['BigInt']>;
  taskId_lte?: InputMaybe<Scalars['BigInt']>;
  taskId_not?: InputMaybe<Scalars['BigInt']>;
  taskId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  token?: InputMaybe<Scalars['String']>;
  token_?: InputMaybe<Token_Filter>;
  token_contains?: InputMaybe<Scalars['String']>;
  token_contains_nocase?: InputMaybe<Scalars['String']>;
  token_ends_with?: InputMaybe<Scalars['String']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']>;
  token_gt?: InputMaybe<Scalars['String']>;
  token_gte?: InputMaybe<Scalars['String']>;
  token_in?: InputMaybe<Array<Scalars['String']>>;
  token_lt?: InputMaybe<Scalars['String']>;
  token_lte?: InputMaybe<Scalars['String']>;
  token_not?: InputMaybe<Scalars['String']>;
  token_not_contains?: InputMaybe<Scalars['String']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']>;
  token_not_ends_with?: InputMaybe<Scalars['String']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  token_not_in?: InputMaybe<Array<Scalars['String']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  token_starts_with?: InputMaybe<Scalars['String']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum Task_OrderBy {
  Amount = 'amount',
  AssignmentDetail = 'assignmentDetail',
  AssignmentDetailUri = 'assignmentDetailUri',
  CancellationDetail = 'cancellationDetail',
  CancellationDetailUri = 'cancellationDetailUri',
  CompletionDetail = 'completionDetail',
  CompletionDetailUri = 'completionDetailUri',
  Contributor = 'contributor',
  CreatedAt = 'createdAt',
  CreationDetail = 'creationDetail',
  CreationDetailUri = 'creationDetailUri',
  Dispute = 'dispute',
  EscrowAddress = 'escrowAddress',
  Fee = 'fee',
  Id = 'id',
  Reviewer = 'reviewer',
  Status = 'status',
  TaskId = 'taskId',
  Token = 'token'
}

export type Token = {
  __typename?: 'Token';
  decimals: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  decimals?: InputMaybe<Scalars['Int']>;
  decimals_gt?: InputMaybe<Scalars['Int']>;
  decimals_gte?: InputMaybe<Scalars['Int']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']>>;
  decimals_lt?: InputMaybe<Scalars['Int']>;
  decimals_lte?: InputMaybe<Scalars['Int']>;
  decimals_not?: InputMaybe<Scalars['Int']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_gt?: InputMaybe<Scalars['String']>;
  symbol_gte?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_lt?: InputMaybe<Scalars['String']>;
  symbol_lte?: InputMaybe<Scalars['String']>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum Token_OrderBy {
  Decimals = 'decimals',
  Id = 'id',
  Name = 'name',
  Symbol = 'symbol'
}

export type User = {
  __typename?: 'User';
  contributorTasks: Array<Task>;
  disputesRaised: Array<Dispute>;
  id: Scalars['ID'];
  reviewerTasks: Array<Task>;
};


export type UserContributorTasksArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Task_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Task_Filter>;
};


export type UserDisputesRaisedArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Dispute_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Dispute_Filter>;
};


export type UserReviewerTasksArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Task_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Task_Filter>;
};

export type User_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  contributorTasks_?: InputMaybe<Task_Filter>;
  disputesRaised_?: InputMaybe<Dispute_Filter>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  reviewerTasks_?: InputMaybe<Task_Filter>;
};

export enum User_OrderBy {
  ContributorTasks = 'contributorTasks',
  DisputesRaised = 'disputesRaised',
  Id = 'id',
  ReviewerTasks = 'reviewerTasks'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type GlobalInfoFragment = { __typename?: 'Global', escrowAddress: any, ownerAddress: any, treasuryAddress: any, arbitratorAddress: any, feePPM: any, chainId: string };

export type CreationInfoFragment = { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null };

export type ApplicationInfoFragment = { __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null };

export type AssignmentInfoFragment = { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null };

export type SubmissionInfoFragment = { __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null };

export type TimelineInfoFragment = { __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null };

export type CompletionInfoFragment = { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null };

export type CancellationInfoFragment = { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null };

export type DisputeRaiseInfoFragment = { __typename?: 'DisputeRaiseDetail', id: string, comment?: string | null, disputeReason?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } };

export type DisputeResolutionInfoFragment = { __typename?: 'DisputeResolutionDetail', id: string, comment?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } };

export type TokenInfoFragment = { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string };

export type TaskInfoFragment = { __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null };

export type DisputeInfoFragment = { __typename?: 'Dispute', id: string, status?: ResolutionStatus | null, task: { __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }, raisedBy: { __typename?: 'User', address: string }, resolvedBy?: { __typename?: 'User', address: string } | null, raiseDetail: { __typename?: 'DisputeRaiseDetail', id: string, comment?: string | null, disputeReason?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } }, resolutionDetail?: { __typename?: 'DisputeResolutionDetail', id: string, comment?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } } | null };

export type UserInfoFragment = { __typename?: 'User', address: string, reviewerTasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }>, contributorTasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }>, disputesRaised: Array<{ __typename?: 'Dispute', id: string, status?: ResolutionStatus | null, task: { __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }, raisedBy: { __typename?: 'User', address: string }, resolvedBy?: { __typename?: 'User', address: string } | null, raiseDetail: { __typename?: 'DisputeRaiseDetail', id: string, comment?: string | null, disputeReason?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } }, resolutionDetail?: { __typename?: 'DisputeResolutionDetail', id: string, comment?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } } | null }> };

export type GetGlobalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalInfoQuery = { __typename?: 'Query', globals: Array<{ __typename?: 'Global', escrowAddress: any, ownerAddress: any, treasuryAddress: any, arbitratorAddress: any, feePPM: any, chainId: string }> };

export type GetTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }> };

export type GetReviewerTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  userAddress?: InputMaybe<Scalars['String']>;
}>;


export type GetReviewerTasksQuery = { __typename?: 'Query', tasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }> };

export type GetContributorTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  userAddress?: InputMaybe<Scalars['String']>;
}>;


export type GetContributorTasksQuery = { __typename?: 'Query', tasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }> };

export type GetTaskQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type GetTaskQuery = { __typename?: 'Query', task?: { __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null } | null };

export type GetUserQueryVariables = Exact<{
  userAddress: Scalars['ID'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', address: string, reviewerTasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }>, contributorTasks: Array<{ __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }>, disputesRaised: Array<{ __typename?: 'Dispute', id: string, status?: ResolutionStatus | null, task: { __typename?: 'Task', id: string, taskId: any, createdAt: any, status: TaskStatus, amount: any, fee: any, token: { __typename?: 'Token', name: string, symbol: string, decimals: number, address: string }, reviewer: { __typename?: 'User', address: string }, contributor?: { __typename?: 'User', address: string } | null, creationDetail: { __typename?: 'TaskCreationDetail', title?: string | null, description?: string | null, content?: string | null, category?: string | null, tags?: Array<string> | null, experience?: string | null, deadline?: any | null, timeEstimateValue?: any | null, timeEstimateUnit?: string | null }, assignmentDetail?: { __typename?: 'TaskAssignmentDetail', message?: string | null, applications?: Array<{ __typename?: 'TaskApplicationDetail', message?: string | null, address?: any | null, timestamp?: any | null }> | null } | null, completionDetail?: { __typename?: 'TaskCompletionDetail', comment?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null, timeline?: Array<{ __typename?: 'TaskTimelineDetail', kind?: string | null, message?: string | null, timestamp?: any | null }> | null } | null, cancellationDetail?: { __typename?: 'TaskCancellationDetail', comment?: string | null, cancellationReason?: string | null, submissions?: Array<{ __typename?: 'TaskSubmissionDetail', message?: string | null, attachments?: Array<string> | null, timestamp?: any | null }> | null } | null }, raisedBy: { __typename?: 'User', address: string }, resolvedBy?: { __typename?: 'User', address: string } | null, raiseDetail: { __typename?: 'DisputeRaiseDetail', id: string, comment?: string | null, disputeReason?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } }, resolutionDetail?: { __typename?: 'DisputeResolutionDetail', id: string, comment?: string | null, dispute: { __typename?: 'Dispute', id: string }, task: { __typename?: 'Task', id: string } } | null }> } | null };

export const GlobalInfoFragmentDoc = gql`
    fragment GlobalInfo on Global {
  chainId: id
  escrowAddress
  ownerAddress
  treasuryAddress
  arbitratorAddress
  feePPM
}
    `;
export const TokenInfoFragmentDoc = gql`
    fragment TokenInfo on Token {
  address: id
  name
  symbol
  decimals
}
    `;
export const CreationInfoFragmentDoc = gql`
    fragment CreationInfo on TaskCreationDetail {
  title
  description
  content
  category
  tags
  experience
  deadline
  timeEstimateValue
  timeEstimateUnit
}
    `;
export const ApplicationInfoFragmentDoc = gql`
    fragment ApplicationInfo on TaskApplicationDetail {
  message
  address
  timestamp
}
    `;
export const AssignmentInfoFragmentDoc = gql`
    fragment AssignmentInfo on TaskAssignmentDetail {
  message
  applications {
    ...ApplicationInfo
  }
}
    ${ApplicationInfoFragmentDoc}`;
export const SubmissionInfoFragmentDoc = gql`
    fragment SubmissionInfo on TaskSubmissionDetail {
  message
  attachments
  timestamp
}
    `;
export const TimelineInfoFragmentDoc = gql`
    fragment TimelineInfo on TaskTimelineDetail {
  kind
  message
  timestamp
}
    `;
export const CompletionInfoFragmentDoc = gql`
    fragment CompletionInfo on TaskCompletionDetail {
  comment
  submissions {
    ...SubmissionInfo
  }
  timeline {
    ...TimelineInfo
  }
}
    ${SubmissionInfoFragmentDoc}
${TimelineInfoFragmentDoc}`;
export const CancellationInfoFragmentDoc = gql`
    fragment CancellationInfo on TaskCancellationDetail {
  comment
  cancellationReason
  submissions {
    ...SubmissionInfo
  }
}
    ${SubmissionInfoFragmentDoc}`;
export const TaskInfoFragmentDoc = gql`
    fragment TaskInfo on Task {
  id
  taskId
  createdAt
  status
  token {
    ...TokenInfo
  }
  reviewer {
    address: id
  }
  contributor {
    address: id
  }
  amount
  fee
  creationDetail {
    ...CreationInfo
  }
  assignmentDetail {
    ...AssignmentInfo
  }
  completionDetail {
    ...CompletionInfo
  }
  cancellationDetail {
    ...CancellationInfo
  }
}
    ${TokenInfoFragmentDoc}
${CreationInfoFragmentDoc}
${AssignmentInfoFragmentDoc}
${CompletionInfoFragmentDoc}
${CancellationInfoFragmentDoc}`;
export const DisputeRaiseInfoFragmentDoc = gql`
    fragment DisputeRaiseInfo on DisputeRaiseDetail {
  id
  dispute {
    id
  }
  task {
    id
  }
  comment
  disputeReason
}
    `;
export const DisputeResolutionInfoFragmentDoc = gql`
    fragment DisputeResolutionInfo on DisputeResolutionDetail {
  id
  dispute {
    id
  }
  task {
    id
  }
  comment
}
    `;
export const DisputeInfoFragmentDoc = gql`
    fragment DisputeInfo on Dispute {
  id
  task {
    ...TaskInfo
  }
  raisedBy {
    address: id
  }
  resolvedBy {
    address: id
  }
  status
  raiseDetail {
    ...DisputeRaiseInfo
  }
  resolutionDetail {
    ...DisputeResolutionInfo
  }
}
    ${TaskInfoFragmentDoc}
${DisputeRaiseInfoFragmentDoc}
${DisputeResolutionInfoFragmentDoc}`;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  address: id
  reviewerTasks {
    ...TaskInfo
  }
  contributorTasks {
    ...TaskInfo
  }
  disputesRaised {
    ...DisputeInfo
  }
}
    ${TaskInfoFragmentDoc}
${DisputeInfoFragmentDoc}`;
export const GetGlobalInfoDocument = gql`
    query GetGlobalInfo {
  globals {
    ...GlobalInfo
  }
}
    ${GlobalInfoFragmentDoc}`;
export const GetTasksDocument = gql`
    query GetTasks($limit: Int) {
  tasks(first: $limit) {
    ...TaskInfo
  }
}
    ${TaskInfoFragmentDoc}`;
export const GetReviewerTasksDocument = gql`
    query GetReviewerTasks($limit: Int, $userAddress: String) {
  tasks(
    first: $limit
    where: {reviewer: $userAddress}
    orderBy: createdAt
    orderDirection: desc
  ) {
    ...TaskInfo
  }
}
    ${TaskInfoFragmentDoc}`;
export const GetContributorTasksDocument = gql`
    query GetContributorTasks($limit: Int, $userAddress: String) {
  tasks(
    first: $limit
    where: {contributor: $userAddress}
    orderBy: createdAt
    orderDirection: desc
  ) {
    ...TaskInfo
  }
}
    ${TaskInfoFragmentDoc}`;
export const GetTaskDocument = gql`
    query GetTask($taskId: ID!) {
  task(id: $taskId) {
    ...TaskInfo
  }
}
    ${TaskInfoFragmentDoc}`;
export const GetUserDocument = gql`
    query GetUser($userAddress: ID!) {
  user(id: $userAddress) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;